import PropTypes from 'prop-types';
import { useStatsigClient } from '@statsig/react-bindings';
import { useNavigate } from 'react-router-dom';
import { CopyIcon, IconCTA, OverlayTriggerTooltip, toast } from '@utilities';
import { copyInstantSurvey } from '@api/instant_survey';
import { GATES } from '@constants';

const Copy = ({
  hasCustomAttribute,
  hasException,
  hasFrozen,
  hasJoined,
  hasPremiumPG,
  hasSmart,
  isHoverAction,
  redirect,
  selectedRows,
  type,
}) => {
  const { client } = useStatsigClient();
  const canCopySurvey = client.checkGate(GATES.COPY_A_SURVEY);
  const navigate = useNavigate();
  const isSurveyCopyAvailable =
    type !== 'Survey' || (canCopySurvey && !selectedRows[0]?.isSurveyDeprecated);

  const isVisible =
    selectedRows.length === 1 &&
    !hasException &&
    !hasCustomAttribute &&
    !hasFrozen &&
    !hasJoined &&
    !hasPremiumPG &&
    !hasSmart &&
    isSurveyCopyAvailable;

  if (!isVisible) return null;

  const handleClick = async () => {
    try {
      let copiedSurveyId;
      if (type === 'Survey') {
        const surveyId = selectedRows[0]?.atlasInstantSurveyRef;
        const copiedSurvey = await copyInstantSurvey({ id: surveyId });
        copiedSurveyId = copiedSurvey?.id;
        if (!copiedSurveyId) {
          throw new Error('Invalid survey data received.');
        }
      }
      const redirectPath =
        type === 'Survey'
          ? `${redirect}/${selectedRows[0]?.instantSurveyTypeId}?ref=${copiedSurveyId}`
          : `${redirect}?id=${selectedRows[0]?.id}`;
      navigate(redirectPath);
    } catch (error) {
      console.error(error);
      toast('Something went wrong during the copy action.', { status: 'error' });
    }
  };

  return (
    <OverlayTriggerTooltip content={isHoverAction ? 'Copy' : ''}>
      <IconCTA
        data-testid="copy-cta"
        icon={<CopyIcon />}
        onClick={handleClick}
        text={isHoverAction ? '' : 'Copy'}
      />
    </OverlayTriggerTooltip>
  );
};

Copy.propTypes = {
  hasCustomAttribute: PropTypes.bool,
  hasException: PropTypes.bool,
  hasFrozen: PropTypes.bool,
  hasJoined: PropTypes.bool,
  hasPremiumPG: PropTypes.bool,
  hasSmart: PropTypes.bool,
  isHoverAction: PropTypes.bool,
  redirect: PropTypes.string,
  selectedRows: PropTypes.array,
  type: PropTypes.string,
};

export default Copy;
